package com.example.mystybag.database.communication.db.daos

import com.example.mystybag.database.communication.db.DatabaseProvider
import kotlinx.datetime.Clock

class ContactLinksDao {

    private val database by lazy { DatabaseProvider.getDatabaseInstance() }
    private val contactQueries = database?.contactImageLinksQueries

    fun getAllContactLinks() = contactQueries?.getAllContactLinks()?.executeAsList()?.associate { it.contact_id to it.link }
    fun getLinkForContactID(contactID: String): String? = contactQueries?.getLinkForContactID(contactID)?.executeAsOneOrNull()?.link
    suspend fun writeContactData(walletID: Long, contactID: String, link: String, name: String, nameSearch: String) {
        contactQueries?.writeContactData(walletID, contactID, link, name, nameSearch, Clock.System.now().toEpochMilliseconds())
    }
    suspend fun deleteUnusedContacts(walletIDs: List<Long>) {
        contactQueries?.deleteUnusedContacts(walletIDs)
    }
    fun getContactNameByWalletID(walletID: Long) = contactQueries?.getContactNameByWalletID(walletID)?.executeAsOneOrNull()?.name
}